import React, {Fragment, Component} from 'react'
import {Route, Switch, Redirect} from 'react-router-dom'
import styled from '@emotion/styled'

import catalogTypes from './catalog-types'
import Header from '../../header/Root'
import GoodPage from '../../good/GoodPage/index'
import CatalogPage from '../CatalogPage'

const PleaseSignIn = styled.div`
  padding: 25px;
  color: black;
  font-size: 16px;
  font-weight: 500;
`

let disclaimerShown = false

class CatalogRoot extends Component {
  state = {
    cart: {}
  }

  setQuantityInCart = (good, quantity) => {
    if (!disclaimerShown) {
      alert('Внимание! Демонстрационная версия нового каталога. В данный момент заказ из него недоступен.')
      disclaimerShown = true
    }

    const parsedQuantity = parseInt(quantity) || 0
    const validatedQuantity = Math.min(good.availableQuantity, parsedQuantity)

    const newCart = {
      ...this.state.cart,
      [good.id]: validatedQuantity
    }

    this.setState({cart: newCart})
  }

  render() {
    const {currentUser} = this.props
    return <div>
      {currentUser ? <Fragment>
        <Header currentUser={currentUser}/>
        <Switch>
          <Route
            path="/app/catalog/good/:goodIdStr"
            render={props => <GoodPage
              {...props}
              currentUser={currentUser}
              cart={this.state.cart}
              setQuantityInCart={this.setQuantityInCart}
            />}
          />
          <Route
            path="/app/catalog/client/:categoryIdStr?"
            render={props => <CatalogPage
              {...props}
              activeCatalogType={catalogTypes.client}
              currentUser={currentUser}
              cart={this.state.cart}
              setQuantityInCart={this.setQuantityInCart}
           />}
          />
          <Route
            path="/app/catalog/main/:categoryIdStr?"
            render={props => <CatalogPage
              {...props}
              activeCatalogType={catalogTypes.main}
              currentUser={currentUser}
              cart={this.state.cart}
              setQuantityInCart={this.setQuantityInCart}
            />}
          />
          <Route
            path="/app/catalog/advance/:categoryIdStr?"
            render={props => <CatalogPage
              {...props}
              activeCatalogType={catalogTypes.advance}
              currentUser={currentUser}
              cart={this.state.cart}
              setQuantityInCart={this.setQuantityInCart}
            />}
          />
          <Redirect to="/app/catalog/client"/>
        </Switch>
      </Fragment> : <PleaseSignIn>
        Для просмотра каталога, пожалуйста, войдите
        на странице <a href="https://mageric.life">mageric.life</a>
      </PleaseSignIn>}
    </div>
  }
}

export default CatalogRoot
